import { Controller } from "@hotwired/stimulus"

// Hides a skeleton overlay once an embedded iframe has finished loading.
export default class extends Controller {
  static targets = [ "skeleton", "frame" ]

  connect() {
    this.hideSkeletonIfReady()
  }

  loaded() {
    this.hideSkeleton()
  }

  hideSkeletonIfReady() {
    if (!this.hasFrameTarget) return

    try {
      const doc = this.frameTarget.contentDocument
      if (doc && doc.readyState === "complete") {
        this.hideSkeleton()
      }
    } catch {
      // Cross-origin iframe — rely on the load event.
    }
  }

  hideSkeleton() {
    if (!this.hasSkeletonTarget) return

    this.skeletonTarget.classList.add("hidden")
    this.skeletonTarget.setAttribute("aria-hidden", "true")
  }
}
